import { toast } from "react-toastify"
import { GetNotificationData } from "./GetNotificationData"

const displayNotification = () => {

    const showNotification = (type: string, msg: string = "") => {
        const data = GetNotificationData(type, msg)
        const toastId = `ci-${type}`

        if (toast.isActive(toastId)) {
            toast.update(toastId, {
                render: data.message,
                ...data,
                toastId
            })
            return
        }

        toast.dismiss();
        toast(data.message, { ...data, toastId })
    }

    const hideNotification = (type: string) => {
        toast.dismiss(type)
    }

    const hideAllNotification = () => {
        toast.dismiss()
    }

    return { showNotification, hideNotification, hideAllNotification }
}

export default displayNotification